import { render, staticRenderFns } from "./CommonTable1.vue?vue&type=template&id=953d3554&scoped=true&"
import script from "./CommonTable1.vue?vue&type=script&lang=js&"
export * from "./CommonTable1.vue?vue&type=script&lang=js&"
import style0 from "./CommonTable1.vue?vue&type=style&index=0&id=953d3554&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "953d3554",
  null
  
)

export default component.exports